/* ==========================================================
   joylïne — interactions page d'accueil
   ========================================================== */
document.addEventListener('DOMContentLoaded', () => {

  /* ---------- Vignette produit : galerie (légère rotation démo) ---------- */
  const galleryMain = document.getElementById('galleryMain');
  document.querySelectorAll('.thumb').forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('thumb--active'));
      thumb.classList.add('thumb--active');
      const device = galleryMain?.querySelector('.gallery-device');
      if (device && device.matches('img')) {
        const fullSrc = thumb.dataset.fullSrc;
        if (fullSrc) device.src = fullSrc;
      } else if (device) {
        const angles = [0, 8, -8, 4];
        device.style.transform = `rotate(${angles[i] || 0}deg)`;
      }
    });
  });

  /* ---------- Vignette produit : variante + panier réel ---------- */
  const teaserVariantsEl = document.querySelector('script[id^="TeaserVariants-"]');
  let teaserVariants = [];
  try { teaserVariants = teaserVariantsEl ? JSON.parse(teaserVariantsEl.textContent) : []; } catch (e) { teaserVariants = []; }

  const teaserAddBtn = document.getElementById('teaserAddToBagBtn');
  document.querySelectorAll('.product .swatches[data-option-index] .swatch').forEach(sw => {
    sw.addEventListener('click', () => {
      const group = sw.closest('.swatches');
      group.querySelectorAll('.swatch').forEach(s => s.classList.remove('swatch--active'));
      sw.classList.add('swatch--active');
      const match = teaserVariants.find(v => v.option1 === sw.dataset.value);
      if (match && teaserAddBtn) teaserAddBtn.dataset.variantId = match.id;
    });
  });

  const teaserQtyValue = document.getElementById('teaserQtyValue');
  document.getElementById('teaserQtyMinus')?.addEventListener('click', () => {
    const v = Math.max(1, parseInt(teaserQtyValue.textContent) - 1);
    teaserQtyValue.textContent = v;
  });
  document.getElementById('teaserQtyPlus')?.addEventListener('click', () => {
    const v = Math.min(9, parseInt(teaserQtyValue.textContent) + 1);
    teaserQtyValue.textContent = v;
  });
  teaserAddBtn?.addEventListener('click', () => {
    const variantId = teaserAddBtn.dataset.variantId;
    const qty = teaserQtyValue ? parseInt(teaserQtyValue.textContent, 10) : 1;
    if (variantId && window.JoylineCart) window.JoylineCart.add(variantId, qty);
  });

  /* ---------- Hero dial notches (5 niveaux d'intensité) ---------- */
  const notchGroup = document.querySelector('.dial-notches');
  if (notchGroup) {
    for (let i = 0; i < 5; i++) {
      const angle = (i / 5) * 360 - 90;
      const rad = (angle * Math.PI) / 180;
      const x1 = 60 + 44 * Math.cos(rad);
      const y1 = 60 + 44 * Math.sin(rad);
      const x2 = 60 + 50 * Math.cos(rad);
      const y2 = 60 + 50 * Math.sin(rad);
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', x1); line.setAttribute('y1', y1);
      line.setAttribute('x2', x2); line.setAttribute('y2', y2);
      line.setAttribute('stroke', '#3A322C');
      line.setAttribute('stroke-width', '1.4');
      line.setAttribute('opacity', '0.35');
      notchGroup.appendChild(line);
    }
  }

  /* ---------- LED chromothérapie : fondu enchaîné image + texte ---------- */
  const chromaSwatches = document.querySelectorAll('.chroma__swatch');
  const chromaPhotos = document.querySelectorAll('.chroma__photo');
  const chromaVisual = document.getElementById('chromaVisual');
  const chromaText = document.getElementById('chromaText');
  const chromaTitle = document.getElementById('chromaTitle');
  const chromaDesc = document.getElementById('chromaDesc');
  let chromaTimer;
  chromaSwatches.forEach(sw => {
    sw.addEventListener('click', () => {
      if (sw.classList.contains('chroma__swatch--active')) return;
      chromaSwatches.forEach(s => {
        s.classList.remove('chroma__swatch--active');
        s.setAttribute('aria-selected', 'false');
      });
      sw.classList.add('chroma__swatch--active');
      sw.setAttribute('aria-selected', 'true');

      const index = sw.dataset.chromaIndex;
      chromaPhotos.forEach(img => {
        const active = img.dataset.chromaIndex === index;
        img.classList.toggle('is-active', active);
        if (active) img.removeAttribute('aria-hidden'); else img.setAttribute('aria-hidden', 'true');
      });
      if (chromaVisual) chromaVisual.style.setProperty('--glow', sw.dataset.chromaColor);

      chromaText?.classList.add('is-fading');
      clearTimeout(chromaTimer);
      chromaTimer = setTimeout(() => {
        if (chromaTitle) chromaTitle.textContent = sw.dataset.chromaTitle;
        if (chromaDesc) chromaDesc.textContent = sw.dataset.chromaDesc;
        chromaText?.classList.remove('is-fading');
      }, 180);
    });
  });

  /* ---------- Slider avant / après ---------- */
  const baSlider = document.getElementById('baSlider');
  const baFrame = baSlider?.querySelector('.ba-slider__frame');
  const baAfter = document.getElementById('baAfter');
  const baHandle = document.getElementById('baHandle');
  let baDragging = false;

  function setBaPosition(clientX) {
    const rect = baFrame.getBoundingClientRect();
    let pct = ((clientX - rect.left) / rect.width) * 100;
    pct = Math.min(96, Math.max(4, pct));
    baAfter.style.clipPath = `inset(0 0 0 ${pct}%)`;
    baHandle.style.left = `${pct}%`;
  }
  function baPointerDown(e) {
    baDragging = true;
    setBaPosition(e.touches ? e.touches[0].clientX : e.clientX);
  }
  function baPointerMove(e) {
    if (!baDragging) return;
    setBaPosition(e.touches ? e.touches[0].clientX : e.clientX);
  }
  function baPointerUp() { baDragging = false; }

  if (baFrame) {
    baHandle.addEventListener('mousedown', baPointerDown);
    baHandle.addEventListener('touchstart', baPointerDown, { passive: true });
    baFrame.addEventListener('mousedown', baPointerDown);
    baFrame.addEventListener('touchstart', baPointerDown, { passive: true });
    window.addEventListener('mousemove', baPointerMove);
    window.addEventListener('touchmove', baPointerMove, { passive: true });
    window.addEventListener('mouseup', baPointerUp);
    window.addEventListener('touchend', baPointerUp);
  }

  /* ---------- Scroll reveal ---------- */
  const revealTargets = document.querySelectorAll(
    '.benefit, .ritual__step, .tech__item, .review, .compare__col, .ugc__tile'
  );
  revealTargets.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity .7s cubic-bezier(.22,.61,.36,1), transform .7s cubic-bezier(.22,.61,.36,1)';
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }, i * 60);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  revealTargets.forEach(el => observer.observe(el));

});
